import React from 'react';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import HolidayVM from './HolidayVM';
import { observer } from 'mobx-react';
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"

@observer
export default class HolidayView extends Views.ViewBase<HolidayVM> {

    constructor(props: unknown) {
        super("Holidays", HolidayVM, props);
    }

    public render() {
        const viewModel = this.viewModel;

        return (
            <Neo.Card title="Edit Holidays">
                <div>
                    <Neo.Form model={viewModel.holidayList} onSubmit={() => viewModel.saveHolidays()} showSummaryModal allReadOnly={!this.viewModel.authorisationService.hasRole(CatalogueRoles.Holidays.Edit)}>

                        <div className="d-flex justify-content-between mb-4">
                            <Neo.Button icon="arrow-left" variant="light" onClick={() => history.back()}>Back</Neo.Button>
                            <Neo.Button
                                isSubmit
                                icon="save"
                                pulse={viewModel.holidayList.isDirty}
                                disabled={!viewModel.holidayList.isDirty}>
                                Save
                            </Neo.Button>
                        </div>

                        <Neo.GridLayout md={3}>
                            <Neo.FormGroup bind={viewModel.meta.selectedYear} dateProps={{ formatString: "yyyy", onDateSelected: () => viewModel.checkIsDirty() }} label="Filter by year:" />
                        </Neo.GridLayout>

                        <NeoGrid.Grid
                            items={viewModel.holidayList}
                            showAddButton>
                            {(item, meta) => (
                                <NeoGrid.Row>
                                    <NeoGrid.Column bind={meta.holidayName} />
                                    <NeoGrid.Column bind={meta.holidayDate} />
                                    <NeoGrid.ButtonColumn showDelete />
                                </NeoGrid.Row>
                            )}
                        </NeoGrid.Grid>
                    </Neo.Form>
                </div>
            </Neo.Card>
        );
    }
}